import {} from "../definition/index.js";
import {} from "./Mod.js";
export function findDefinition(mod, name) {
    return mod.definitions.get(name);
}
//# sourceMappingURL=findDefinition.js.map